module.exports = __webpack_public_path__ + "static/media/15UN-Habitat5.5266f78d.jpg";